import { SliderWithTooltip } from 'app/components/playback/slider-with-tooltip';
import { styled } from 'styled-components';

export const StyledSlider = styled(SliderWithTooltip)`
  margin: ${({ theme }) => theme.spacing(2)}px 0;
`;

export const EventNoisePlaybackSliderWrapper = styled.div``;
